import { Config } from "~/constants/configuration_provider";
import { pluralize } from "~/lib/pluralize";

export function formatTokenExpiration(seconds: number): string {
  if (seconds < 60) {
    return `${Math.round(seconds)} ${pluralize("second", seconds)}`;
  }
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  if (remainingSeconds === 0) {
    return `${minutes} ${pluralize("minute", minutes)}`;
  }
  return `${minutes} ${pluralize("minute", minutes)} and ${Math.round(remainingSeconds)} ${pluralize("second", remainingSeconds)}`;
}

export const getLinuxInstallCommand = (
  tokenValue: string,
) => `export MONDOO_REGISTRATION_TOKEN='${tokenValue}'
curl -sSL https://${Config.VITE_INSTALL_HOST}/sh | bash -s -- -u enable -s enable -t $MONDOO_REGISTRATION_TOKEN`;
